import {DialogConfig} from '@angular/cdk/dialog';

/**
 * App-wide defaults for every CDK dialog, provided as DEFAULT_DIALOG_CONFIG in app.config.
 *
 * CDK uses a provided default *instead of* its own (`this._defaultOptions || new DialogConfig()`), so every
 * CDK default this object leaves out is simply unset. For closeOnNavigation that meant false: browser Back
 * left the open dialog on screen over the previous page (VTK-3234). It is set here once for all dialogs.
 *
 * closeOnNavigation reacts to popstate/hashchange -- Back/Forward and hash edits; a router.navigate() from
 * inside a dialog does not close it. disableClose only stops the backdrop click and Escape.
 *
 * The other CDK defaults stay off as they have always been here (autoFocus, restoreFocus): turning them on
 * changes focus behaviour in every dialog and is a separate decision. closeOnOverlayDetachments, which closing
 * on navigation relies on, needs nothing -- CDK only skips it when it is explicitly false.
 */
export const DIALOG_DEFAULTS: DialogConfig = {
  hasBackdrop: true,
  disableClose: true,
  width: '720px',
  // Kept as it was. Not a DialogConfig field (that would be maxWidth), so it has never had an effect.
  ...({'max-width': '100%'} as DialogConfig),
  closeOnNavigation: true,
};
